import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const DomainDeletesPage = lazy(() => import('./DomainDeletesPage'));
const path = 'reports/domain-count/deletes';
const DomainDeletesRoute: FuseRouteItemType = {
	path: path,
	element: <DomainDeletesPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Domain Deletes',
					helpName: 'Domain Deletes',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default DomainDeletesRoute;
